import { render, staticRenderFns } from "./electric-add-batch.vue?vue&type=template&id=6df0abcc&scoped=true&"
import script from "./electric-add-batch.vue?vue&type=script&lang=js&"
export * from "./electric-add-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0abcc",
  null
  
)

export default component.exports